// componentRoutes.js
import { lazy } from "react";

const AddComponent = lazy(() => import("./AddComponent"));
const ComponentList = lazy(() => import("./ComponentList"));
const ChildPartList = lazy(() => import("./ChildPartList"));
const ImportChildParts = lazy(() => import("./ImportChildParts"));
const ComponentWorkOrderList = lazy(() => import("./ComponentWorkOrderList"));
const ComponentImportWO = lazy(() => import("./ComponentImportWO"));
const ImportPDIParameters = lazy(() => import("../part/ImportPDIParameters"));
const DailyOperation = lazy(() => import("../part/DailyOperation"));
const DailyOperationEmployeeSelect = lazy(() => import("../part/DailyOperationEmployeeSelect"));
const DailyOperationLogs = lazy(() => import("../part/DailyOperationLogs"));
const Quality = lazy(() => import("../part/Quality"));
const Dispatch = lazy(() => import("../part/Dispatch"));

const componentRoutes = [
  { path: "/component/add", element: <AddComponent /> },
  { path: "/component/list", element: <ComponentList /> },
  { path: "/component/child-part-list", element: <ChildPartList /> },
  { path: "/component/child-part-import", element: <ImportChildParts /> },
  { path: "/component/work-order-list", element: <ComponentWorkOrderList /> },
  { path: "/component/work-order-import", element: <ComponentImportWO /> },
  { path: "/component/quality", element: <Quality operationScope="component" /> },
  { path: "/component/dispatch", element: <Dispatch operationScope="component" /> },
  { path: "/component/pdi-parameter-import", element: <ImportPDIParameters /> },
  { path: "/component/daily-operation", element: <DailyOperation operationScope="component" /> },
  { path: "/component/daily-operation/select-employee", element: <DailyOperationEmployeeSelect operationScope="component" /> },
  { path: "/component/daily-operation-logs", element: <DailyOperationLogs operationScope="component" /> },
  { path: "/component/daily-operation-log", element: <DailyOperationLogs operationScope="component" /> }
];

export default componentRoutes;
